<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Career page') }}</h4>
        </div>
        <div class="btn-row">
          <div class="form-inline">
            <input-keyword
              @input="setKeywords"
              :placeholder="$t('Search')"
              class="mr-2" />
            <button
              type="button"
              class="btn btn-primary"
              @click="showCreateModal()">
              + {{ $t('New page') }}
              </button>
          </div>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">

      <Paginaty
        :total="paginate.total"
        :pages="paginate.pages"
        :page="paginate.page"
        :creating="creating"
        :loading="loading"
        @changePage="loadData">
        
        <template slot="content">
          <table class="table">
            <thead>
              <tr>
                <th-sort field="title" :value="sort" @input="setSort">{{ $t('Title') }}</th-sort>
                <th-sort field="slug" :value="sort" @input="setSort">Slug</th-sort>
                <th-sort field="default" :value="sort" @input="setSort">{{ $t('Default') }}</th-sort>
                <th class="text-truncate">{{ $t('Edit') }}</th>
                <th class="text-truncate">{{ $t('View') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in careerpages"
                :key="index">
                <td class="text-truncate"><a href="javascript:void(0)" @click="showEditModal(item)">{{ item.title }}</a></td>
                <td class="text-truncate">{{ item.slug }}</td>
                <td class="text-truncate">{{ item.default ? $t('Yes') : '--' }}</td>
                <td class="text-truncate"><a :href="item.builder_url + '/' + $store.getters.authToken" target="_blank"><i class="fas fa-external-link-alt" /> {{ $t('Edit page') }}</a></td>
                <td class="text-truncate"><a :href="item.career_url" target="_blank"><i class="fas fa-external-link-alt" /> {{ $t('View page') }}</a></td>
              </tr>
            </tbody>
          </table>
        </template>

        <template slot="noresults">
          {{ $t('There are no items') }}
        </template>

      </Paginaty>

      <careerpage-form 
        v-if="modal_select"
        :initCareerpage="modal_select" 
        @hideModal="hideModal ()" 
        @deleted="loadData(); hideModal()" 
        @saved="loadData(paginate.page); hideModal()" 
        ></careerpage-form>

    </div>

  </div>

</template>

<script>
import InputKeyword from '@/components/Fields/InputKeyword'
import CareerpageForm from './CareerpageForm'
import ThSort from '@/components/Parts/ThSort'
import Paginaty from '@/components/Paginaty/Paginaty'

export default {
  name: 'CareerpagePages',
  components: {
    CareerpageForm,
    InputKeyword,
    ThSort,
    Paginaty
  },
  data () {
    return {
      creating: true,
      loading: true,
      modal_select: false,
      filters: {},
      sort: 'name'
    }
  },
  computed: {
    careerpages () {
      return this.$store.getters.getCareerpages
    },
    paginate () {
      return this.$store.getters.getCareerpagesPaginate
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData (page) {
      this.loading = true

      const params = {
        ...this.filters,
        page: page,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.$store
      .dispatch('selectCareerpages', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.loadData(1)
        this.loading = this.creating = false
      })
    },
    /*
    filters
    */
    setKeywords (keywords) {
      this.filters = keywords ? {name: '~' + keywords} : {}
      this.loadData(1)
    },
    setSort (sort) {
      this.sort = sort
      this.loadData(1)
    },
    /*
    modal
    */
    showCreateModal () {
      this.modal_select = {}
    },
    showEditModal (item) {
      this.modal_select = item
    },
    hideModal () {
      this.modal_select = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Careerpage/CareerpagePages.vue